'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _middleware = require('../../middleware');

var _paths = require('./paths');

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key] = value;
  }return obj;
}

exports.default = function (feis_id, event_id, adj_id, person_id, data) {
  return function (dispatch, getState) {
    return dispatch(_defineProperty({
      feis_id: feis_id,
      event_id: event_id,
      adj_id: adj_id,
      person_id: person_id

    }, _middleware.CALL_API, {
      config: {
        url: (0, _paths.commentsPrefixUrl)(feis_id, event_id, adj_id, person_id),
        method: 'POST',
        data: data
      },
      types: ['CREATE_COMMENT_START', 'CREATE_COMMENT', 'CREATE_COMMENT_ERROR']
    }));
  };
};


//////////////////
// WEBPACK FOOTER
// /Users/vidhigupta/isomorphic/lib/redux/actions/comments/createComment.js
// module id = 619
// module chunks = 0